import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=2d50ea39&scoped=true&"
import script from "./AdminHeader.vue?vue&type=script&lang=js&"
export * from "./AdminHeader.vue?vue&type=script&lang=js&"
import style0 from "styles/components/adminHeader.css?vue&type=style&index=0&id=2d50ea39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d50ea39",
  null
  
)

export default component.exports